import {
  CreditcardRegisterError,
  stringifyErrorForEndUser as stringifyCreditcardRegisterError
} from '@/models/payment/creditcard/repository/errors'
import { BaseError } from '@/util/base-error'

export class SubscribePaidMembershipPlanError extends BaseError {
  constructor(message: string, readonly label: string) {
    super(message)
  }
}

export abstract class RegisterCreditcardToSubscribePlanError extends BaseError {
  static causedBy(
    cause: Error,
    f: new (message: string) => RegisterCreditcardToSubscribePlanError
  ): RegisterCreditcardToSubscribePlanError {
    return new f(`${cause.name}:${cause.message}`)
  }

  abstract get label(): string
}

export class FailedToRemoveOldCreditcardError extends RegisterCreditcardToSubscribePlanError {
  get label(): string {
    return [
      'クレジットカードの更新中にエラーが発生しました。時間をおいて、再度お試しください。',
      '※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。',
    ].join('<br/>')
  }
}

type ExpectedError = SubscribePaidMembershipPlanError
  | RegisterCreditcardToSubscribePlanError
  | CreditcardRegisterError
  | Error
export function stringifyErrorForEndUser(e: ExpectedError): string {
  if (e instanceof CreditcardRegisterError) {
    return stringifyCreditcardRegisterError(e)
  }

  return (
    e instanceof SubscribePaidMembershipPlanError
    || e instanceof RegisterCreditcardToSubscribePlanError
  )
    ? e.label
    : 'エラーが発生しました。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
}
